import { HubFeature, WuserCandRestrictType } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Web User Candidate Restriction Type`;

export type CPWuserCandRestrictTypeLocs =
	| 'CPWuserCandRestrictTypeEnumFiltered'
	| 'CPWuserCandRestrictTypeEnumRestricted'
	| 'CPWuserCandRestrictTypeEnumUnrestricted';

export type SPWuserCandRestrictTypeLocs =
	| 'SPWuserCandRestrictTypeEnumFiltered'
	| 'SPWuserCandRestrictTypeEnumRestricted'
	| 'SPWuserCandRestrictTypeEnumUnrestricted';

export const cpWuserCandRestrictTypeEnumLocs: LocDefs<CPWuserCandRestrictTypeLocs> = {
	CPWuserCandRestrictTypeEnumFiltered: {
		defaultValue: 'Filtered',
		displayPath: `${dpRoot}|${WuserCandRestrictType.Filtered}`,
		description: `System value for '${WuserCandRestrictType.Filtered}' web user candidate restriction type`,
		displayType: 'Content',
		feature: HubFeature.Core,
		portal: 'CP',
	},
	CPWuserCandRestrictTypeEnumRestricted: {
		defaultValue: 'Restricted',
		displayPath: `${dpRoot}|${WuserCandRestrictType.Restricted}`,
		description: `System value for '${WuserCandRestrictType.Restricted}' web user candidate restriction type`,
		displayType: 'Content',
		feature: HubFeature.Core,
		portal: 'CP',
	},
	CPWuserCandRestrictTypeEnumUnrestricted: {
		defaultValue: 'Unrestricted',
		displayPath: `${dpRoot}|${WuserCandRestrictType.Unrestricted}`,
		description: `System value for '${WuserCandRestrictType.Unrestricted}' web user candidate restriction type`,
		displayType: 'Content',
		feature: HubFeature.Core,
		portal: 'CP',
	},
};

export const spWuserCandRestrictTypeEnumLocs: LocDefs<SPWuserCandRestrictTypeLocs> = {
	SPWuserCandRestrictTypeEnumFiltered: {
		defaultValue: 'Filtered',
		displayPath: `${dpRoot}|${WuserCandRestrictType.Filtered}`,
		description: `System value for '${WuserCandRestrictType.Filtered}' web user candidate restriction type`,
		displayType: 'Content',
		feature: HubFeature.Core,
		portal: 'SP',
	},
	SPWuserCandRestrictTypeEnumRestricted: {
		defaultValue: 'Restricted',
		displayPath: `${dpRoot}|${WuserCandRestrictType.Restricted}`,
		description: `System value for '${WuserCandRestrictType.Restricted}' web user candidate restriction type`,
		displayType: 'Content',
		feature: HubFeature.Core,
		portal: 'SP',
	},
	SPWuserCandRestrictTypeEnumUnrestricted: {
		defaultValue: 'Unrestricted',
		displayPath: `${dpRoot}|${WuserCandRestrictType.Unrestricted}`,
		description: `System value for '${WuserCandRestrictType.Unrestricted}' web user candidate restriction type`,
		displayType: 'Content',
		feature: HubFeature.Core,
		portal: 'SP',
	},
};

export const WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS = MapLocKeys<
	CPWuserCandRestrictTypeLocs | SPWuserCandRestrictTypeLocs
>({
	...cpWuserCandRestrictTypeEnumLocs,
	...spWuserCandRestrictTypeEnumLocs,
});

export type CPWuserCandRestrictTypeEnumLocType = LocMap<CPWuserCandRestrictTypeLocs>;
export type SPWuserCandRestrictTypeEnumLocType = LocMap<SPWuserCandRestrictTypeLocs>;

export const cpWuserCandRestrictTypeKeys: {
	[key in WuserCandRestrictType]: keyof CPWuserCandRestrictTypeEnumLocType;
} = {
	Filtered: WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS.CPWuserCandRestrictTypeEnumFiltered,
	Restricted: WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS.CPWuserCandRestrictTypeEnumRestricted,
	Unrestricted: WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS.CPWuserCandRestrictTypeEnumUnrestricted,
};

export const spWuserCandRestrictTypeKeys: {
	[key in WuserCandRestrictType]: keyof SPWuserCandRestrictTypeEnumLocType;
} = {
	Filtered: WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS.SPWuserCandRestrictTypeEnumFiltered,
	Restricted: WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS.SPWuserCandRestrictTypeEnumRestricted,
	Unrestricted: WUSER_CAND_RESTRICT_TYPE_ENUM_LOCS.SPWuserCandRestrictTypeEnumUnrestricted,
};
